import React, { useEffect } from "react";
import { Form, Typography } from "antd";
import ModalActions from "../../components/forms/ModalActions";
import { FormattedMessage } from "react-intl";
import OrderFormRows from "./OrderFormRows";
import { useIntl } from "react-intl";
import useOrderForm from "./useOrderForm";
import moment from "moment";
const { Text } = Typography;

const OrderForm = (props) => {
  const { type, actionAfterSubmit, onConfirm, selectedOrder, setForm } = props;
  const [form] = Form.useForm();
  const intl = useIntl();
  const {
    activeOrder,
    createLoading,
    onFinish,
    onFinishFailed,
    onFormChange,
    disabledFromDate,
    disabledDate,
    isSupportingCommunity,
    isDayCenter,
    clientCategories,
    orderIsUsed,
    onClientCategoriesChanged,
    filter,
    selectedClient,
    hasEditorPermission,
    getServiceTypeLabel,
    serviceType,
    startDate,
    noEndDate,
    isTrom,
    filterOrderServiceTypes,
    filterContracts,
    filterClientFrameSymbols,
    filterClientTariffSymbols,
    changedValues,
    scopePrefix,
    activePatient,
    isMentoring,
    selectedClientTariffSymbol,
    selectedRevahaAuthority,
  } = useOrderForm(form, type, selectedOrder, actionAfterSubmit);

  useEffect(() => {
    setForm?.(form);
  }, [form, setForm]);

  const layout = {
    labelCol: { span: 10 },
    wrapperCol: { span: 14 },
  };

  return (
    <Form
      {...layout}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      onValuesChange={(changedValues, allValues) =>
        onFormChange(form, changedValues, allValues)
      }
      form={form}
    >
      <OrderFormRows
        form={form}
        clientCategories={clientCategories}
        orderIsUsed={orderIsUsed}
        onClientCategoriesChanged={onClientCategoriesChanged}
        filter={filter}
        selectedClient={selectedClient}
        hasEditorPermission={hasEditorPermission}
        getServiceTypeLabel={getServiceTypeLabel}
        serviceType={serviceType}
        startDate={startDate}
        disabledFromDate={disabledFromDate}
        disabledDate={disabledDate}
        noEndDate={noEndDate}
        isTrom={isTrom}
        isMentoring={isMentoring}
        filterOrderServiceTypes={filterOrderServiceTypes}
        filterContracts={filterContracts}
        filterClientFrameSymbols={filterClientFrameSymbols}
        filterClientTariffSymbols={filterClientTariffSymbols}
        activeOrder={activeOrder}
        changedValues={changedValues}
        isSupportingCommunity={isSupportingCommunity}
        isDayCenter={isDayCenter}
        type={type}
        scopePrefix={scopePrefix}
        activePatient={activePatient}
        intl={intl}
        selectedClientTariffSymbol={selectedClientTariffSymbol}
        selectedRevahaAuthority={selectedRevahaAuthority}
      />
      <div>
        {type === "edit" ? (
          activeOrder.updated_by_user ? (
            <Text type="secondary">{`${intl.formatMessage({
              id: "app.forms.order.update_by",
            })} ${activeOrder.updated_by_user} ${intl.formatMessage({
              id: "app.forms.order.at",
            })} ${moment(activeOrder.updated_at).format("DD/MM/YYYY")}`}</Text>
          ) : (
            <Text> </Text>
          )
        ) : null}

        {activeOrder.updated_from_file === true && (
          <div style={{ marginTop: "4px" }}>
            <Text type="secondary">
              {intl.formatMessage({
                id: "app.forms.order.update_by_file",
              })}
            </Text>
          </div>
        )}
      </div>

      <ModalActions
        loading={createLoading}
        hideDecline={true}
        onConfirm={onConfirm}
        approveTitle={
          type === "edit" ? (
            <FormattedMessage id="app.actions.saveChanges" />
          ) : (
            <FormattedMessage id="app.orders.addNewOrder" />
          )
        }
      />
    </Form>
  );
};

export default OrderForm;
